import { render } from "./safety-tags.vue?vue&type=template&id=29367964&scoped=true&ts=true"
import script from "./safety-tags.vue?vue&type=script&lang=ts"
export * from "./safety-tags.vue?vue&type=script&lang=ts"

import "./safety-tags.vue?vue&type=style&index=0&id=29367964&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29367964"]])

export default __exports__